function BlogDetails() {
  const blogPosts = [
    {
      title: "Top Car Transport Airport Services for Seamless Travel Experience",
      image: "https://empirelimotransfer.com/wp-content/uploads/2025/12/Top-Car-Transport-Airport-Services-for-Seamless-Travel-Experience.png",
      link: "/blog"
    },
    {
      title: "Top Private Car Airport Services for Reliable and Safe Transfers",
      image: "https://empirelimotransfer.com/wp-content/uploads/2025/12/Private-Car-Airport-Service-Overview.png",
      link: "/blog"
    },
    {
      title: "Top Airport Car Service: Reliable Transportation for Every Traveler",
      image: "https://empirelimotransfer.com/wp-content/uploads/2025/12/Introduction-to-Airport-Car-Service.png",
      link: "/blog"
    }
  ];

  return (
    <section className="bg-white py-12">
      <div className="max-w-[1200px] mx-auto px-4">
        
        {/* Our Blogs Heading */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-2xl font-bold text-black mb-4">Our Blogs</h2>
          <p className="text-lg text-gray-900">Explore Our Blogs</p>
        </div>

        {/* Blog Post Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
              {/* Blog Image */}
              <div className="h-64 overflow-hidden bg-gray-200">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<div class="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center"><span class="text-6xl">📰</span></div>';
                  }}
                />
              </div>
              
              {/* Blog Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-black mb-6 leading-tight min-h-[3rem]">{post.title}</h3>
                <a 
                  href={post.link}
                  className="inline-block bg-black text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors"
                >
                  Learn more
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BlogDetails;
